export default __webpack_public_path__ + "static/media/insuranceCeoImage.032c0350.svg";